import { msg } from 'gt-react';
import { BuildingsIcon } from '@phosphor-icons/react';
import { Action, Subject } from '@erp/authz';
import { ProductModule } from '@erp/shared-types';
import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { z } from 'zod';
import { Route as pathlessAuthenticatedRoute, requireModules } from '../route';

const CustomersPage = lazyRouteComponent(() => import('./CustomersPage'));

export const Route = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/customers',
  staticData: {
    app: {
      nav: {
        label: msg('Customers', {
          context: 'sidebar nav label, Sales section',
        }),
        icon: <BuildingsIcon className="h-4 w-4" weight="fill" />,
        group: 'Sales',
        order: 10,
        groupOrder: 10,
      },
      access: {
        modulesAnyOf: [ProductModule.ORDER_MANAGEMENT],
        permissionsAnyOf: [
          { action: Action.Read, subject: Subject.Customer },
          { action: Action.Read, subject: Subject.Company },
        ],
      },
    },
  },
  component: CustomersPage,
  loader: () => ({
    crumb: msg('Customers', { context: 'page breadcrumb' }),
  }),
  beforeLoad: ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.ORDER_MANAGEMENT],
    });
  },
  validateSearch: z.object({
    customerId: z.string().optional(),
    page: z.coerce.number().int().min(1).optional(),
    pageSize: z.coerce.number().int().min(1).max(100).optional(),
    name: z.string().optional(),
    accountNumber: z.string().optional(),
    columns: z.array(z.string()).optional(),
  }),
});
